<template>
  <div>
      <Head :title="__(title)" />
    <div class="bg-white rounded-md shadow overflow-hidden max-w-3xl">
      <form @submit.prevent="update">
          <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
              <text-input v-model="form.name" :error="form.errors.name" class="pr-6 pb-8 w-full lg:w-1/2" :label="__('Name')" />
              <select-input v-model="form.department_id" :error="form.errors.department_id" class="pr-6 pb-8 w-full lg:w-1/2" :label="__('Department')">
                <option :value="null">{{ __('Select Department') }}</option>
                <option v-for="department in departments" :key="department.id" :value="department.id">{{ department.name }}</option>
              </select-input>
          </div>
        <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex items-center">
          <button v-if="!channel.deleted_at" class="text-red-600 hover:underline" tabindex="-1" type="button" @click="destroy">{{ __('Delete Channel') }}
            </button>
          <loading-button :loading="form.processing" class="btn-indigo ml-auto" type="submit">{{ __('Update Channel') }}
            </loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import { Link, Head } from '@inertiajs/vue3'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'

export default {
  metaInfo() {
    return { title: this.form.name }
  },
  components: {
    LoadingButton,
    TextInput,
    SelectInput,
    Link,
      Head,
  },
  layout: Layout,
  props: {
      title: String,
    channel: Object,
    departments: Array,
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
          name: this.channel.name,
          department_id: this.channel.department_id,
      }),
    }
  },
  created() {
  },
  methods: {
    update() {
      this.form.put(this.route('channels.update', this.channel.id))
    },
    destroy() {
      if (confirm('Are you sure you want to delete this channel?')) {
        this.$inertia.delete(this.route('channels.destroy', this.channel.id))
      }
    },
    restore() {
      if (confirm('Are you sure you want to restore this channel?')) {
        this.$inertia.put(this.route('channels.restore', this.channel.id))
      }
    },
  },
}
</script>
